import React from 'react'

/* mui */
import Grid from '@material-ui/core/Grid'
/* mui */

const index = props => {
  return (
    <Grid container spacing={2}>
      {props.children}
    </Grid>
  )
}

export default index
